import React from 'react';

interface HideIconProps {
  width?: number | string;
  height?: number | string;
  fill?: string;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
}

const HideIcon: React.FC<HideIconProps> = ({ 
  width = 24, 
  height = 24, 
  fill = '#989898',
  color,
  className,
  style 
}) => {
  const fillColor = color || fill;
  
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path
        d="M3.57568 3.57613C3.81 3.34181 4.19 3.34181 4.42432 3.57613L20.4243 19.5761C20.6582 19.8104 20.6582 20.1895 20.4243 20.4238C20.19 20.6581 19.81 20.6581 19.5757 20.4238L16.5532 17.4013C15.1961 18.0989 13.6518 18.5996 11.9995 18.5996C8.21372 18.5994 4.96008 15.9901 3.16357 14.2041C2.70702 13.7502 2.36343 13.4219 2.1626 12.8066C2.08235 12.5606 2.05323 12.2623 2.05322 12C2.05322 11.7376 2.0823 11.4394 2.1626 11.1933C2.36352 10.5778 2.70797 10.2487 3.16553 9.7939C3.98024 8.98413 5.07317 8.02655 6.36475 7.21285L3.57568 4.42378C3.34162 4.18952 3.34162 3.81039 3.57568 3.57613ZM7.23877 8.08687C5.945 8.86678 4.83614 9.82554 4.01123 10.6455C3.52793 11.1258 3.40135 11.2649 3.30322 11.5654C3.27688 11.6461 3.25244 11.8056 3.25244 12C3.25245 12.1939 3.27693 12.3526 3.30322 12.4335C3.40136 12.7344 3.52763 12.8737 4.01025 13.3535C5.77252 15.1054 8.72451 17.3992 11.9995 17.3994C13.2802 17.3994 14.5156 17.0473 15.6587 16.5068L13.3638 14.2119C12.9671 14.4569 12.4997 14.5996 11.9995 14.5996C10.5637 14.5994 9.3999 13.4358 9.3999 12C9.3999 11.4996 9.54255 11.0323 9.7876 10.6357L7.23877 8.08687ZM11.9995 5.40035C15.7855 5.40035 19.0398 8.00978 20.8364 9.79585C21.2929 10.2497 21.6367 10.5789 21.8374 11.1943C21.9175 11.4402 21.9477 11.7376 21.9478 12C21.9478 12.2624 21.9177 12.5604 21.8374 12.8066C21.6382 13.417 21.2971 13.7444 20.8462 14.1923L20.8472 14.1933C20.8432 14.1975 20.8385 14.202 20.8345 14.206C20.5531 14.4857 20.239 14.7822 19.896 15.0839C19.6472 15.3027 19.2681 15.278 19.0493 15.0293C18.8307 14.7804 18.8553 14.4013 19.104 14.1826C19.4268 13.8986 19.7229 13.6187 19.9888 13.3544L19.9917 13.3515C20.4732 12.8729 20.599 12.7342 20.6968 12.4345C20.7231 12.3539 20.7476 12.1944 20.7476 12C20.7475 11.806 20.7231 11.6472 20.6968 11.5664C20.5987 11.2656 20.4727 11.1256 19.9907 10.6464C18.2284 8.89446 15.2749 6.59956 11.9995 6.59956C11.6887 6.59958 11.3804 6.62016 11.0757 6.65913C10.7471 6.70101 10.4468 6.46917 10.4048 6.14058C10.3628 5.81204 10.5949 5.51195 10.9233 5.46968C11.2762 5.42454 11.6355 5.40036 11.9995 5.40035ZM10.6001 12C10.6001 12.773 11.2265 13.4001 11.9995 13.4003C12.1646 13.4003 12.3224 13.3696 12.4692 13.3173L10.6812 11.5293C10.6287 11.6763 10.6001 11.8346 10.6001 12Z"
        fill={fillColor}
      />
    </svg>
  );
};

export default HideIcon;
